import { render, staticRenderFns } from "./EmailTemplateSender.vue?vue&type=template&id=0149848c"
import script from "./EmailTemplateSender.vue?vue&type=script&lang=js"
export * from "./EmailTemplateSender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports